"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The abstract super-type implementation of a page.
 */
var PageComponent = /** @class */ (function () {
    function PageComponent() {
    }
    /**
     * Probably should return RouteSegment or anything to identify the route.
     * @returns {null} as for now, but should be implemented properly
     */
    PageComponent.prototype.getReferrerData = function () {
        return null;
    };
    return PageComponent;
}());
exports.PageComponent = PageComponent;
//# sourceMappingURL=page.component.js.map